import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({
    providedIn: 'root'
})
export class LoggedInGuard implements CanActivate {
    constructor(private userService: UserService, private router: Router) {}
    canActivate(): boolean | UrlTree {
        if (this.userService.userData !== null) {
            return true;
        }
        return this.router.createUrlTree(['login']);
    }
}
